import React from 'react'
import { UserWeddingRole } from '../../types/wedding'

const WelcomeScreen = ({userWeddingRole, name}: {userWeddingRole: UserWeddingRole, name: string}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="text-center">
        {/* Glowing orb effect */}
        <div className="relative inline-block mb-8">
          {/* Outer glow - largest */}
          <div className="absolute inset-0 w-48 h-48 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            <div className="w-full h-full rounded-full bg-[#5DBD9C]  blur-3xl animate-pulse"></div>
          </div>
          
          {/* Middle glow */}
          <div className="absolute inset-0 w-32 h-32 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            <div className="w-full h-full rounded-full bg-[#5DBD9C] opacity-50 blur-2xl"></div>
          </div>
          
          {/* Inner glow */}
          <div className="absolute inset-0 w-20 h-20 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            <div className="w-full h-full rounded-full bg-[#5DBD9C] opacity-60 blur-xl"></div>
          </div>
          
          {/* Core circle */}
          <div className="relative w-16 h-16 rounded-full bg-gray-200 shadow-lg">
            <img src="/images/face.png" alt="" className="w-full h-full rounded-full" />
          </div>
        </div>
        
        {/* Text content */}
        <h1 className="text-3xl md:text-4xl font-light text-gray-800 mb-2 uppercase optima tracking-wide">
          WELCOME, {userWeddingRole} OF THE YEAR
        </h1>
        <p className="text-sm md:text-base text-black font-light tracking-widest optima uppercase">
          {name}
        </p>
      </div>
    </div>
  )
}

export default WelcomeScreen